module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (11).a5d6eae8.jpg";